<mobi-ui-concierge-major
    [title]="'osm.footer.concierge.title' | translate"
    [subtitle]="'osm.footer.concierge.subtitle' | translate"
>
    <div class="mobi-ui-container">
        <div class="mobi-ui-grid is-centered">
            <div class="mobi-ui-col-1/1 xs:mobi-ui-col-1/2 md:mobi-ui-col-1/3 xl:mobi-ui-col-1/4">
                <a
                    class="mobi-ui-card-major is-clickable is-small is-row"
                    [href]="'Tel:' + phoneNr"
                >
                    <div class="mobi-ui-text-block-major is-small">
                        <mobi-ui-icon-major name="phone"></mobi-ui-icon-major>
                        <div class="mobi-ui-text-block-content-major">
                            <span class="mobi-ui-text-block-label-major">{{
                                'osm.footer.concierge.card.call.title' | translate
                            }}</span>
                            <span class="mobi-ui-text-block-content-major">
                                {{ phoneDisplay }}
                            </span>
                        </div>
                    </div>
                </a>
            </div>
            <div class="mobi-ui-col-1/1 xs:mobi-ui-col-1/2 md:mobi-ui-col-1/3 xl:mobi-ui-col-1/4">
                <a
                    class="mobi-ui-card-major is-clickable is-small is-row"
                    [href]="'mailto:' + ('osm.footer.concierge.card.email.address' | translate)"
                >
                    <div class="mobi-ui-text-block-major is-small">
                        <mobi-ui-icon-major name="mail_electronic"></mobi-ui-icon-major>
                        <div class="mobi-ui-text-block-content-major">
                            <span class="mobi-ui-text-block-label-major">
                                {{ 'osm.footer.concierge.card.email.title' | translate }}
                            </span>
                            <span class="mobi-ui-text-block-content-major">
                                {{ 'osm.footer.concierge.card.email.address' | translate }}
                            </span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</mobi-ui-concierge-major>
